import { BasicLayout } from '@pages/layouts/BasicLayout';
import { AccountPage } from '@pages/user/account/ui/AccountPage';
import { defaultLocale } from '@shared/lib/i18n';
import type { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
export const getServerSideProps: GetServerSideProps = async context => ({
  props: {
    ...(await serverSideTranslations(context.req.cookies.LOCALE || defaultLocale, ['translation', 'account']))
  }
});
export default function Account() {
  const {
    t
  } = useTranslation('translation');
  return <>
      <Head>
        <title>{t('navigation.account')}</title>
      </Head>
      <BasicLayout>
        <AccountPage />
      </BasicLayout>
    </>;
}